import { Component, OnInit } from '@angular/core';
import { LoginRedirectService } from '@core/services/auth/login-redirect.service';

@Component({
  selector: 'signup',
  template: '',
})
export class SignupComponent implements OnInit{
  constructor(
    private loginRedirect: LoginRedirectService
  ) { }
  
  ngOnInit(): void {
    this.loginRedirect.loginWithRedirect({
      redirect: window.location.origin,
      authorizationParams: {
        screen_hint: 'signup',
      }
    });
  }
}
